var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import React, { Component } from "react";
import Clipboard from "react-copy-to-clipboard";
import { colors } from "@wrstudios/theme";
import { IconCopy } from "@wrstudios/icons";
import { Container, MlsNumLayout, CopyMLSNum, MLSNum, Icon, Copied, Courtesy } from "./styled/listing-disclaimer";

var ListingDisclaimer =
/** @class */
function (_super) {
  __extends(ListingDisclaimer, _super);

  function ListingDisclaimer() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      copied: false
    };

    _this.handleCopy = function () {
      _this.setState({
        copied: true
      });
    };

    return _this;
  }

  ListingDisclaimer.prototype.render = function () {
    var _a = this.props,
        mlsnum = _a.mlsnum,
        mlsnumColor = _a.mlsnumColor,
        updatedAtDateShort = _a.updatedAtDateShort,
        updatedAtTime = _a.updatedAtTime,
        officeName = _a.officeName;
    return React.createElement(Container, null, mlsnum && React.createElement(MlsNumLayout, null, React.createElement(Clipboard, {
      text: mlsnum,
      onCopy: this.handleCopy
    }, React.createElement(CopyMLSNum, null, "MLS #", " ", React.createElement(MLSNum, {
      className: "mlsnum",
      style: {
        color: mlsnumColor
      }
    }, mlsnum), " ", React.createElement(Icon, null, React.createElement(IconCopy, null)))), this.state.copied && React.createElement(Copied, null, "Copied!")), updatedAtDateShort && React.createElement("div", null, "Last Updated " + updatedAtDateShort + " at " + updatedAtTime), officeName && React.createElement(Courtesy, null, "Courtesy of ", officeName));
  };

  ListingDisclaimer.prototype.componentDidUpdate = function (prevProps, prevState) {
    var _this = this;

    if (!prevState.copied && this.state.copied) {
      setTimeout(function () {
        _this.setState({
          copied: false
        });
      }, 2000);
    }
  };

  ListingDisclaimer.defaultProps = {
    mlsnumColor: colors.streams[500]
  };
  return ListingDisclaimer;
}(Component);

export default ListingDisclaimer;